/**
 * @copyright Microsoft Corporation. All rights reserved.
 *
 * @file FileCard social bar component
 */

import * as React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { ActivityItem } from 'office-ui-fabric-react/lib/components/ActivityItem/index';
// import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { WithAction, IActionStateProps } from '../../withAction/WithAction';
import { ShowSocialBarAction } from '../../actions/analyticsClick/ShowSocialBarAction';

import * as SocialBarStyle from './SocialBar.scss';
import * as AnalyticsStatsStyle from './AnalyticsStats.scss';

export interface ISocialBarLikeLinkProps {
  onRenderUser?: () => void;
  onCloseClick?: () => void;
  likeLabel: string;
  itemKey: string;
}

export class SocialBarLikeLink extends React.Component<ISocialBarLikeLinkProps, {}> {
  constructor(props: ISocialBarLikeLinkProps) {
    super(props);
  }

  public render(): React.ReactElement<{}> {
    const { likeLabel, itemKey } = this.props;
    const likeLinkLabel = (
      <ActivityItem
        activityDescription={
          <div className='ms-AnalyticsStats--stats--label'>
            { <div className='ms-AnalyticsStats--stats--count like'>{ likeLabel }</div> }
          </div>
        }
        isCompact={ true }
      />
    );

    return (
      <WithAction
        action={ <ShowSocialBarAction itemKey={ itemKey } /> }
      >
        { ({ isAvailable, execute }: IActionStateProps) => {
          const onClick = isAvailable ? () => {
            execute().catch(() => {
              // Ignore errors.
            });
          } : undefined;

          return (
            <div className={ `${SocialBarStyle.socialBarLikeSection}` }>
              <Link
                disabled={ false }
                className={ `${AnalyticsStatsStyle.msAnalyticsStatsStatsStatsLink}` }
                onClick={ onClick }
              >
                {
                  likeLinkLabel
                }
              </Link>
            </div >
          );
        } }
      </WithAction>
    );
  }
}
